import { ApiState, createCachedApiReducer } from '../../../../utils/api-state';
import { combineReducers, createFeatureSelector, createReducer, on } from '@ngrx/store';
import {
  getPaperlessActions,
  getProfileEmailActions,
  getProfileResidenceActions,
  getProfileResidenceClearActions,
  getProfileResidenceFailureActions,
  getProfileResidenceSuccessActions,
  updateProfileEmailSuccess,
} from '../actions/profile.actions';
import { ProfileEmailGetResponse, ProfileResidenceResponse } from '../../models/profile-residence.model';
import { ProfilePaperlessNormalized } from '../../models/profile-paperless.model';

export interface ProfileState {
  residence: ProfileResidenceState;
  email: ApiState<ProfileEmailGetResponse>;
  paperless: ApiState<ProfilePaperlessNormalized>;
}

export interface ProfileResidenceState {
  processing: boolean;
  processed: boolean;
  error: any;
  response: ProfileResidenceResponse[];
}

const initialProfileResidenceState: ProfileResidenceState = {
  processing: false,
  processed: false,
  error: null,
  response: null,
};

const profileResidenceReducer = createReducer(
  initialProfileResidenceState,
  on(getProfileResidenceActions, (state) => ({
    ...state,
    processing: true,
    processed: false,
    error: null,
  })),
  on(getProfileResidenceSuccessActions, (state, action) => ({
    ...state,
    processing: false,
    processed: true,
    response: action.data,
    error: null,
  })),
  on(getProfileResidenceFailureActions, (state, action) => ({
    ...state,
    processed: true,
    error: action.error,
    processing: false,
    response: null,
  })),
  on(getProfileResidenceClearActions, () => ({
    ...initialProfileResidenceState,
  }))
);

const profileEmailReducer = createCachedApiReducer(
  getProfileEmailActions,
  undefined,
  on(updateProfileEmailSuccess, (state, { response }) => {
    return {
      ...state,
      response: { ...state.response, email: response.reqBody.email },
    };
  })
);

export const profileReducers = combineReducers<ProfileState>({
  residence: profileResidenceReducer,
  email: profileEmailReducer,
  paperless: createCachedApiReducer(getPaperlessActions),
});

export const createProfileState = createFeatureSelector<ProfileState>('profile');
